import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as svc from "../../api/bankService";
import { getApiErrorMessage } from "../../utils/apiError";

export const fetchBanks = createAsyncThunk("bank/fetchAll", async (params) => {
  const res = await svc.getBanks(params);
  return res.data;
});

export const createBankThunk = createAsyncThunk("bank/create", async (data, { rejectWithValue }) => {
  try {
    const res = await svc.createBank(data);
    return res.data;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to create bank."));
  }
});

export const updateBankThunk = createAsyncThunk("bank/update", async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await svc.updateBank(id, data);
    return res.data;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to update bank."));
  }
});

export const deleteBankThunk = createAsyncThunk("bank/delete", async (id, { rejectWithValue }) => {
  try {
    await svc.deleteBank(id);
    return id;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to delete bank."));
  }
});

const bankSlice = createSlice({
  name: "bank",
  initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBanks.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchBanks.fulfilled, (state, action) => { state.loading = false; state.list = action.payload; })
      .addCase(fetchBanks.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(createBankThunk.fulfilled, (state, action) => { state.list.push(action.payload); })
      .addCase(updateBankThunk.fulfilled, (state, action) => {
        const id = action.payload.bankID || action.payload.id;
        const idx = state.list.findIndex((b) => (b.bankID || b.id) === id);
        if (idx !== -1) state.list[idx] = action.payload;
      })
      .addCase(deleteBankThunk.fulfilled, (state, action) => {
        state.list = state.list.filter((b) => (b.bankID || b.id) !== action.payload);
      });
  },
});

export default bankSlice.reducer;
